import HttpClient from '@naturehouse/nh-essentials/lib/requests/HttpClient';
import HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import captureSafeException from '../../../util/sentry';

export default class CheckUnreadChatMessagesComponent {
    private readonly context: ContextInterface;

    private readonly cssClass: string;

    constructor(context: ContextInterface) {
        this.context = context;
        this.cssClass = 'chat-unread';
    }

    public onInit(): void {
        this.checkUnread();
    }

    private checkUnread(): void {
        if (!this.context.bindings.endpoint) {
            return;
        }

        HttpClient.get(this.context.bindings.endpoint)
            .then((response: unknown): void => {
                const unreadChatMessagesResponse = response as UnreadChatMessagesResponse;
                if (unreadChatMessagesResponse && unreadChatMessagesResponse.unread > 0) {
                    this.context.element.classList.add(this.cssClass);
                } else {
                    this.context.element.classList.remove(this.cssClass);
                }
            })
            .catch((error: unknown): void => {
                if (!(error instanceof HttpError)) {
                    return;
                }
                captureSafeException(error, 'failed_to_check_unread_chat_messages', this.context);
            });
    }

    static getClassName(): string {
        return 'CheckUnreadChatMessagesComponent';
    }
}
